import { ComponentProps } from 'react';
import { VariantProps } from 'tailwind-variants';
import { answer, answerBadge, answerIcon } from './variants';
import { CheckIcon, InfoIcon, XIcon } from 'morpheus-ui';

type AnswerProps = ComponentProps<'button'> &
  VariantProps<typeof answer> & {
    variant?: string;
    number: number;
    selected?: boolean;
    done?: boolean;
    text?: string;
  };

const iconMap = {
  correct: CheckIcon,
  incorrect: XIcon,
  undefined: InfoIcon,
  discursive: InfoIcon,
  selected: InfoIcon,
};

function Answer({
  variant = 'undefined',
  number,
  selected = false,
  done = false,
  text,
  className,
  ...props
}: AnswerProps) {
  const IconComponent = iconMap[variant];

  return (
    <button {...props} className={answer({ variant, selected, className })}>
      {text ? text : number.toString().padStart(2, '0')}
      {done && ['correct', 'incorrect'].includes(variant) ? (
        <div className={answerBadge({ variant })}>
          <IconComponent className={answerIcon({ variant })} />
        </div>
      ) : null}
    </button>
  );
}

export { Answer };
